import { render, staticRenderFns } from "./studioDashboardWebsiteContent.vue?vue&type=template&id=6bc23a13&scoped=true"
import script from "./studioDashboardWebsiteContent.vue?vue&type=script&lang=js"
export * from "./studioDashboardWebsiteContent.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardWebsiteContent.vue?vue&type=style&index=0&id=6bc23a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc23a13",
  null
  
)

export default component.exports